import { Heading, TextBlock } from '@ui'

const component = (
    <>
        <div className="mb-5 m:mb-12 m:-mx-6 m:py-6 m:px-6 m:bg-sand-light">
            <Heading
                text="NAUDOJIMOSI SĄLYGOS"
                className="m:hidden"
                size="s"
                component="h1"
            />
            <Heading
                text="NAUDOJIMOSI SĄLYGOS"
                className="hidden m:block"
                size="m"
                component="h1"
            />
        </div>
        <Heading
            text="SUTARTIS DĖL MUITINĖS TARPININKO PASLAUGŲ TEIKIMO"
            className="mb-3"
            size="xs"
            component="h2"
        />
        <Heading
            text="1. Bendrosios nuostatos"
            className="mb-3"
            size="xs"
            component="h2"
        />
        <TextBlock className="mb-9 m:mb-12">
            <p>
                1.1. Ši muitinės tarpininko paslaugų teikimo sutartis, sudaroma
                tarp UAB „Trevio“ (veikiančio kaip oficialaus muitinės
                tarpininko) valdomos muitinės paslaugų teikimo platformos
                www.deklaruok24.lt (toliau – „Pardavėjas“) ir kliento (toliau –
                „Pirkėjas“), nustato su prekių deklaravimu LR muitinei susijusių
                paslaugų teikimo sąlygas, teises bei įsipareigojimus.
            </p>
            <p>
                1.2. Privatumo Politika - reglamentuoja UAB Trevio muitinės
                paslaugų teikimo platformos deklaruok24.lt ir Pirkėjo
                pagrindinius asmens duomenų rinkimo, tvarkymo ir saugojimo
                principus bei tvarką.
            </p>
            <p>
                1.3. Pirkėjas - asmuo, užsakantis muitinio deklaravimo paslaugą
                LR muitinėje per deklaruok24.lt platformą
            </p>
            <p>
                1.4. Pardavėjas - juridinis asmuo UAB "Trevio", įregistruotas
                Lietuvos Respublikos VĮ "Registrų centras". Juridinio asmens
                kodas 305433599, adresas Naujoji 124-801, Alytus, LT62175. PVM
                mokėtojo kodas LT100013610514.
            </p>
            <p>1.5. Šalys - Pirkėjas ir Pardavėjas kartu.</p>
            <p>
                1.6. Internetinė platforma - www.deklaruok24.lt interneto adresu
                pasiekiama prekių deklaravimo LR muitinei platforma, valdoma
                “Pardavėjo”.
            </p>
            <p>
                1.7. Muitinės tarpininko paslaugų teikimo sutartis – tai tarp
                Pirkėjo ir Pardavėjo sudaryta nuotolinė paslaugų teikimo
                sutartis, kuri laikoma sudaryta nuo to momento, kai Pirkėjas
                internetinėje platformoje www.deklaruok24.lt, įvedęs siuntos
                Nr., nurodęs ir patvirtinęs teisingus siuntos duomenis,
                patvirtinęs paskaičiuotus mokesčius, pasirinkęs apmokėjimo būdą
                ir susipažinęs (perskaitęs ir pažymėjęs varnele „Sutinku su
                Naudojimosi taisyklėmis”, “Sutinku su privatumo politika“ ir
                “Sutinku su paslaugos teikimo sąlygomis”), paspaudžia apmokėjimo
                su nurodyta mokėtina suma mygtuką.
            </p>
        </TextBlock>
        <Heading
            text="2. Sutarties objektas"
            className="mb-3"
            size="xs"
            component="h2"
        />
        <TextBlock className="mb-9 m:mb-12">
            <p>
                2.1. Lietuvos Respublikos įstatymų ir kitų teisės aktų nustatyta
                tvarka “Pardavėjas” teikia “Pirkėjui” muitinės tarpininko
                paslaugas, ir atstovauja “Pirkėją” muitinės įstaigoje įforminant
                “Pirkėjo” nurodytų prekių muitinės bendrąjį dokumentą (toliau
                tekste - BAD) ir pateikiant jį ir kitus reikalingus dokumentus
                ir duomenis muitiniam tikrinimui bei teikia kitas šioje
                sutartyje nurodytas su prekių deklaravimu bei su muitiniu
                tikrinimu susijusias paslaugas, o “Pirkėjas” už suteiktas
                paslaugas sumoką nustatytą kainą.
            </p>
            <p>
                2.2. “Pirkėjas” suteikia “Pardavėjui” teises ir įgaliojimus
                veikti “Pirkėjo” vardu ir “Pirkėjo” interesais. “Pirkėjas” taip
                pat suteikia “Pardavėjui” teisę perleisti jam suteiktus
                įgaliojimus tokia forma ir apimtimi, kaip jie apibrėžti šioje
                Sutartyje, kitam šios Sutarties vykdymui pasitelktam asmeniui,
                laikantis visų tarpusavio konfidencialumo reikalavimų.
            </p>
            <p>
                2.3. “Pirkėjo” užsakymai “Pardavėjui” teikiami “Pirkėjo” arba jo
                pasirinkto vežėjo iniciatyva per interneto svetainę
                www.deklaruok24.lt.
            </p>
        </TextBlock>
        <Heading
            text="3. “Pardavėjo” teisės ir pareigos"
            className="mb-3"
            size="xs"
            component="h2"
        />
        <TextBlock className="mb-4 m:mb-12">
            <p>
                <b>3.1. “Pardavėjas”, vykdydamas šią sutartį, įsipareigoja:</b>
            </p>
            <p>
                3.1.1. vykdyti LR įstatymuose ir kituose teisės aktuose, prekių
                deklaravimo ir muitinio tikrinimo nuostatuose nustatytas
                muitinės tarpininko pareigas, naudotis juose nustatytomis
                teisėmis bei vykdyti juose nustatytas pareigas;
            </p>
            <p>
                3.1.2. tinkamai deklaruoti pateiktas per deklaruok24.lt
                platformą “Pirkėjo” prekes ir pateikti jas muitiniam tikrinimui;
            </p>
            <p>
                3.1.3. muitinei pareikalavus, pateikti sutarties su “Pirkėju”
                pagrindžiančius įrodymus, liudijančius teisėtą “Pirkėjo”
                atstovavimą, taip pat kitus dokumentus, susijusius su Muitinės
                tarpininko veikla;
            </p>
            <p>
                3.1.4 Garantuoti pateiktos konfidencialios informacijos apsaugą;
            </p>
            <p>
                3.1.5. Garantuoti, kad muitinės tarpininko paslaugas teiks tik
                turintys šią teisę Muitinės tarpininko atstovai.
            </p>
            <p>
                3.1.6. Laikyti skaitmeninių laikmenų archyvuose ir muitinei
                pareikalavus pateikti įformintų BAD duomenis raštu ar
                magnetinėse laikmenuose
            </p>
        </TextBlock>
        <Heading
            text="4. “Pirkėjo” teisės ir pareigos"
            className="mb-3"
            size="xs"
            component="h2"
        />
        <TextBlock className="mb-8 m:mb-0">
            <p>
                <b>4.1. “Pirkėjas”, vykdydamas šią sutartį, įsipareigoja:</b>
            </p>
            <p>
                4.1.1. Įvedus siuntos numerį sistemoje deklaruok24.lt,
                pavirtinti pateikiamų sistemoje prekių aprašymus, duomenis ir
                paskaičiuotus mokesčius. Jei duomenys neatitinka faktinių
                dokumentų duomenų– įsipareigoja juos patikslinti.{' '}
            </p>
            <p>
                4.1.2. “Pardavėjui” pareikalavus, įsipareigoja pateikti
                patikslinančius ar papildomus dokumentus /duomenis skaitmeniniu
                būdu per deklaruok24.lt platformą ar tuo pačiu komunikaciniu
                kanalu, kuriuo buvo pateiktas “Pardavėjo” užklausa.
            </p>
            <p>
                4.1.3. Visi sistemoje deklaruok24.lt tvirtinami “Pirkėjo”
                duomenys ir dokumentai turi būti galiojantys, o juose pateikiama
                informacija turi atitikti prekių deklaravimo ir muitinio
                tikrinimo nuostatų bei teisės aktų nustatytus reikalavimus.
            </p>
            <p>
                4.1.4. “Pirkėjas” pilnai atsako už tvirtinamų dokumentų ir
                duomenų teisingumą ir pilną atitikimą prekės aprašymui. Jei
                “Pardavėjas” prašo pateikti ar patikslinti duomenis ar dokumentų
                teisingumą, tai pateikiami dokumentai ir duomenys privalo būti
                originalūs. “Pirkėjas” pilnai atsako už dokumentų vertimą,
                sertifikatų ir leidimų savalaikį pateikimą.
            </p>
            <p>
                4.1.5. “Pirkėjas” privalo turėti elektroninėje deklaracijoje
                nurodytus dokumentus, tvarkingai juos saugoti ne trumpiau kaip 8
                metus po atitinkamos elektroninės deklaracijos įforminimo, kaip
                tai numatyta Lietuvos Respublikos muitinės įstatymo 25
                straipsnyje, ir užtikrinti, kad muitinei būtų prieinami ir/arba
                muitinei pareikalavus, pateikti šiuos dokumentus tikrinti
                (išskyrus dokumentus, kurie atlikus jų muitinį tikrinimą
                paliekami muitinėje).
            </p>
            <p>
                <b>
                    4.2. Dokumentų forma ir juose pateikiama informacija turi
                    atitikti prekių deklaravimo ir muitinio tikrinimo nuostatų,
                    teisės aktų nustatytus reikalavimus
                </b>
            </p>
            <p>
                <b>
                    4.3. „Pirkėjas“ įsipareigoja nedelsiant koreguoti ir
                    ištaisyti duomenis ir informaciją pateiktoje deklaruok24.lt
                    platformoje, jei ji yra neteisinga.
                </b>
            </p>
            <p>
                <b>
                    4.4. Už „Pirkėjo“ pateiktų ir patvirtintų neteisingų duomenų
                    sukeltus padarinius atsako „Pirkėjas“.
                </b>
            </p>
        </TextBlock>
        <Heading
            text="5. Paslaugos kaina ir atsiskaitymo tvarka"
            className="mb-3"
            size="xs"
            component="h2"
        />
        <TextBlock className="mb-8 m:mb-0">
            <p>
                5.1. Paslaugų kainos deklaruok24.lt platformoje nurodomos eurais
                su tuo metu galiojančiu pridėtinės vertės mokesčiu, jei jis yra
                taikomas (PVM). Jos taip pat pateikiamos apmokant už paslaugą.
            </p>
            <p>
                5.2. Už paslaugas „Pirkėjas“ gali atsiskaityti vienu iš šių
                būdų:
                <br />- naudodamasis e-bankininkyste;
                <br />- naudodamasis banko mokėjimo korele.
            </p>
            <p>
                5.3. Atlikus mokėjimą, “Pirkėjas“ gauna tai patvirtinantį
                pranešimą.
            </p>
        </TextBlock>
        <Heading
            text="6. Šalių atsakomybė"
            className="mb-3"
            size="xs"
            component="h2"
        />
        <TextBlock className="mb-8 m:mb-0">
            <p>
                “Pirkėjas” atsako už dokumentų vertimų, sertifikatų, leidimų ar
                kitų reikalingų muitiniam įforminimui dokumentų savalaikį
                pateikimą, jei to paprašo “Pardavėjas” muitinės nurodymu. Jeigu
                “Pirkėjas” dėl savo kaltės laiku nepateikia aukščiau minėtų
                dokumentų ir dėl jo kaltės “Pardavėjas” turi nuostolių, tai
                “Pirkėjas” turi apmokėti su tuo susijusias išlaidas.
            </p>
            <p>
                6.2. “Pirkėjas” atsako už patvirtintų duomenų deklaruok24.lt
                platformoje prekių aprašymų ir pateiktų duomenų teisingumą ir
                pilną atitikimą prekei, o pateikiami dokumentų egzemplioriai, jų
                pareikalavus, privalo būti originalūs. Jei “Pirkėjas”
                nesilaikytų šios pareigos ir dėl šios priežasties “Pardavėjas”
                patirtų kokių nors nuostolių, įskaitant ir “Pardavėjui”, kaip
                muitinės tarpininko atstovui paskirtas administracines baudas,
                “Pirkėjas” įsipareigoja juos atlyginti.
            </p>
            <p>
                6.3. “Pardavėjas” neatsako už trečiųjų asmenų veiksmus, kai
                pasinaudoję “Pirkėjo” elektroninės bankininkystės sistema, jie
                pasinaudoja deklaruok24.lt paslaugomis.
            </p>
        </TextBlock>
        <Heading
            text="7. Baigiamosios nuostatos"
            className="mb-3"
            size="xs"
            component="h2"
        />
        <TextBlock className="mb-8 m:mb-0">
            <p>
                7.1. Sutartis įsigalioja nuo “Pirkėjo” pažymėjimo varnele
                platformoje deklaruok24.lt, kad jis sutinka su “Paslaugų teikimo
                sąlygomis”
            </p>
            <p>
                7.2. “Pirkėjo” sutikimas su šiomis sąlygomis ir patvirtinimas
                varnele deklaruok24.lt platformoje laikomas abiejų šalių
                pasirašyta sutartimi ir galioja kaip oficialus dokumentas,
                turintis juridinę galią.
            </p>
            <p>
                7.3. “Pardavėjas” pasilieka teisę savo nuožiūra pildyti ar
                keisti šias Taisykles ir kitus su Taisyklėmis susijusius
                dokumentus, apie tai “Pirkėją” informuodamas deklaruok24.lt
                platformoje. Sutarties papildymai ar pakeitimai įsigalioja nuo
                jų paskelbimo dienos, t.y. nuo tos dienos, kai jie yra
                patalpinami deklaruok24.lt platformoje.
            </p>
            <p>
                7.4. Jeigu “Pirkėjas” nesutinka su šia sutartimi ar nauja
                sutarties redakcija, daliniais papildymais ar pakeitimais,
                tuomet “Pirkėjas” turi teisę jų atsisakyti, su sąlyga, kad
                “Pirkėjas” praranda teisę naudotis deklaruok24.lt platformos
                paslaugomis.
            </p>
            <p>
                7.5. Jei po Taisyklių pakeitimo “Pirkėjas” ir toliau naudojasi
                deklaruok24.lt platformos teikiamomis paslaugomis, laikoma, kad
                “Pirkėjas” sutinka su nauja sutarties redakcija, daliniais
                pakeitimais ar papildymais.
            </p>
            <p>
                7.6. Kiekviena sutarties šalis turi teisę nutraukti šią sutartį,
                apie sutarties nutraukimą pranešdama kitai šaliai raštu prieš
                penkias darbo dienas.
            </p>
            <p>
                7.7. Visi Šalių įsipareigojimai, prisiimti iki sutarties
                nutraukimo, lieka galioti iki jų pilno įvykdymo.
            </p>
            <p>
                7.8. Visa informacija, “Pardavėjo” (kaip muitinės tarpininko)
                gauta iš “Pirkėjo”, laikytina konfidenciali informacija, kurios
                “Pardavėjas” negali atskleisti jokiems tretiesiems asmenims, ir
                kurią gali naudoti tik tiek ir toje apimtyje, kurios reikia
                Muitinės tarpininko įsipareigojimų, numatytų šioje sutartyje,
                tinkamam įvykdymui.
            </p>
            <p>
                7.9. Visi nesutarimai dėl šios sutarties vykdymo sprendžiami
                derybų keliu. Nepavykus susitarti per 30 (trisdešimt) dienų,
                nesutarimai sprendžiami Lietuvos Respublikos įstatymų nustatyta
                tvarka Arbitražiniame teisme Vilniuje.
            </p>
            <p>7.10. Šiai sutarčiai yra taikoma Lietuvos Respublikos teisė.</p>
            <br />
            <br />
            <p>Galioja nuo 2021 m. Lapkričio 01 d.</p>
            <p>Paskutinį kartą atnaujinta 2021m. Lapkričio 01d., 00:00</p>
        </TextBlock>
        <Heading
            text="NAUDOJIMOSI INSTRUKCIJA"
            className="mb-3"
            size="xs"
            component="h2"
        />
        <TextBlock className="mb-8 m:mb-0">
            <br />
            <p>
                1. Randate savo siuntą paieškoje arba gaunate SMS/el. laišką su
                nuoroda į ją.
            </p>
            <p>2. Sistema suformuoja importo deklaraciją.</p>
            <p>
                3. Užsakote paslaugą. <strong>Čia jūsų darbas baigtas!</strong>
            </p>
            <p>4. Sistema deklaruoja siuntą.</p>
            <p>5. Kurjeris užbaigia pristatymą Jums.</p>
            <br />
            <br />
            <p>
                Taip pat deklaruok24.lt sistemoje galite: atsisakyti siuntos,
                deklaruoti kitur, pateikti papildomus duomenis arba esamų
                duomenų patikslinimą. Šiuos veiksmus galima pasirinkti pirmame
                deklaravimo proceso žingsnyje.
            </p>
            <p>
                <a
                    href="https://deklaruok24.lt/lt/#faq"
                    target="_blank"
                    rel="noreferrer"
                >
                    Dažniausiai užduodamų klausimų skiltyje
                </a>{' '}
                rasite atsakymus į daugumą galinčių iškilti klausimų.
            </p>
        </TextBlock>
        <Heading
            text="PREKIŲ UŽSAKYMAS IR ATSISKAITYMAS"
            className="mb-3"
            size="xs"
            component="h2"
        />
        <TextBlock className="mb-8 m:mb-0">
            <br />
            <p>
                1. Pirkėjas paslaugą (importo deklaracijos parengimą ir įforminimą muitinėje) Tinklapyje užsisakyti gali gavęs el. laišką/SMS apie siuntą arba įvedęs turimą siuntos sekimo numerį.
            </p>
            <p>
                2. Už paslaugą (importo deklaracijos parengimą ir įforminimą muitinėje) Pirkėjas gali atsiskaityti naudojantis elektronine bankininkyste arba mokėjimo kortele.
            </p>
            <p>
                3. Kai Pirkėjas atlieka paskutinį Užsakymo pateikimo žingsnį (atlieka mokėjimą už paslaugą), laikoma, kad tarp Šalių sudaryta Sutartis ir tarp jų atsirado pirkimo-pardavimo teisiniai santykiai. Pirkėjas apie deklaracijos Užsakymo priėmimą informuojamas užsakymo patvirtinimo lange.
            </p>
            <p>
                4. Pirkėjo Užsakymas saugomas Tinklapyje.
            </p>
            <p>
                5. Atlikus paslaugą (įforminus deklaraciją), vežėjas automatiškai gauna informaciją apie galimybę pristatyti deklaruotinas prekes gavėjui. Jeigu įforminti nepavyksta dėl muitinės papildomos informacijos poreikio - yra susisiekiama su gavėju SMS arba el. paštu ir prašoma pateikti papildomą informaciją. Jeigu vykdomas muitinės prekių patikrinimas - apie tai gali būti informuojamas ir gavėjas bet tik tais atvejais, kai to reikalauja situacija pagal teisės aktus.
            </p>
            <p>
                6. Patvirtindamas Taisykles, Pirkėjas sutinka, kad Prekių pirkimo dokumentas (PVM sąskaita-faktūra) jam gali būti pateikiamas po Užsakymo įvykdymo, to paprašius adresu info@deklaruok24.lt. Dokumente nurodomi Pardavėjo rekvizitai ir Pirkėjas, užsakyta paslauga, mokesčiai, galutinė kaina ir kiti duomenys.
            </p>
            <p>
                7. Pinigų grąžinimas. Prekių importo deklaravimas, tai paslauga, vykdoma automatizuotai todėl po apmokėjimo už paslaugą automatiškai vykdomi tolimesni procesai ir pinigai persigalvojus šiame etape nėra grąžinami. Atsisakyti paslaugos vykdymo galima prieš apmokėjimą - pasirinkus deklaruoti kitur arba atsisakius siuntos.
            </p>
        </TextBlock>
    </>
)

export default component
